import React, { FC } from 'react';
import IComponentProps from 'interfaces/IComponentProps';
import styled from 'styled-components';
import colors from 'const/style/colors';
import fonts from 'const/style/fonts';

export interface IModalProps extends IComponentProps {
  dim?: boolean;
  open?: boolean;
  frame?: boolean;
};

const Frame = styled.div`
  display:none;
  flex-direction:row;
  justify-content:center;
  align-items:center;
  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  z-index:999;

  .dimmer {
    position:fixed;
    top:0;
    left:0;
    width: 100%;
    height: 100%;
    background-color:${colors.C000000};
    opacity:0.5;
    z-index:5;
  }
  div:not(.dimmer) {
    z-index:9999;
  }
  .frame-modal {
    min-width:500px;
    min-height:200px;
    padding-top:57px;
    padding-bottom:50px;
    background:${colors.CFFFFFF};
    text-align:center;
    box-shadow: 0px 11px 27px ${colors.C00000033};
    ${fonts.H2_Bold};
    white-space:pre;
  }
  .black{
    ${fonts.H2_Bold};
    color:black;
   }
  .btn-cta {
    width:200px;
    height:40px;
    background-color:${colors.C2E303C};
    ${fonts.H2_White};
    border-radius:5px;
    margin-top:26px;
    margin-left:10px;
    margin-right:10px;
    padding-bottom:2px;
    cursor:pointer;
  }
  .btn-cta2 {
    width:200px;
    height:40px;
    background-color:white;
    border: 1px solid #2E303C;
    ${fonts.H2_Bold};
    border-radius:5px;
    margin-top:26px;
    margin-left:10px;
    margin-right:10px;
    padding-bottom:2px;
    cursor:pointer;
  }
  &.open {
    display:flex;
    .frame-modal {
      animation: modal-fade-in 1s ease forwards;
    }
  }

  @keyframes modal-fade-in {
    0% {
      transform: translate(0,-10px);
      opacity:0;
    }
    100% {
      transform: translate(0,0);
      opacity:100%;
    }
  }
`

const Modal:FC<IModalProps> = ({dim = true, children, open=false, frame=true}) => {
  return (
    <Frame className={`${open && 'open'}`}>
      {
        dim &&
        <div className='dimmer'>
        </div>
      }
      {
        frame?
          <div className='frame-modal'>
            {children}
          </div>
          :
          <div>
            {children}
          </div>
      }
    </Frame>
  )
}

export default Modal;